<details class="decision-assistant">
  <summary>Ask AI about this decision (optional)</summary>
  @if (config(); as assistant) {
    <div class="assistant-body">
      <p>
        Ask for clarification or a second perspective on this frozen explanation. AI answers are
        advice only and may be wrong.
      </p>
      <p class="no-action-copy">
        This assistant cannot select, save, submit, approve, create a pull request, or take any
        other action.
      </p>
      @if (turns().length > 0) {
        <div class="assistant-turns" aria-label="AI question and answer history">
          @for (turn of turns(); track turn.turnId) {
            <article class="assistant-turn">
              <p class="assistant-turn-status" aria-live="polite" aria-atomic="true">
                @if (turn.status === 'answered') {
                  Answer ready from {{ modelLabel(turn.modelRoute) }}.
                } @else if (turn.status === 'failed') {
                  No answer was produced.
                } @else {
                  Answer pending.
                }
              </p>
              <dl class="turn-exchange">
                <div class="turn-message">
                  <dt class="turn-label">You asked</dt>
                  <dd class="plain-text turn-question">
                    <app-safe-link-text [text]="turn.question" />
                  </dd>
                </div>
                <div class="turn-message assistant-response">
                  <dt class="turn-label">{{ modelLabel(turn.modelRoute) }} response</dt>
                  @if (turn.status === 'answered') {
                    <dd class="turn-answer">
                      @for (block of answerDisplayBlocks(turn.answer); track $index) {
                        @switch (block.kind) {
                          @case ('ordered-list') {
                            <ol [attr.start]="block.start">
                              @for (item of block.items; track $index) {
                                <li class="plain-text">
                                  <app-safe-link-text [tokens]="item.tokens" />
                                </li>
                              }
                            </ol>
                          }
                          @case ('unordered-list') {
                            <ul>
                              @for (item of block.items; track $index) {
                                <li class="plain-text">
                                  <app-safe-link-text [tokens]="item.tokens" />
                                </li>
                              }
                            </ul>
                          }
                          @default {
                            <p class="plain-text">
                              <app-safe-link-text [tokens]="block.tokens" />
                            </p>
                          }
                        }
                      }
                      <app-safe-link-text
                        [text]="turn.answer ?? ''"
                        [showText]="false"
                        [showPreview]="true"
                      />
                    </dd>
                  } @else if (turn.status === 'failed') {
                    <dd class="turn-failed">No answer was produced for this question.</dd>
                  } @else {
                    <dd>Answer pending…</dd>
                  }
                </div>
              </dl>
            </article>
          }
        </div>
      }
      <div class="assistant-form">
        <label for="decision-assistant-model">Model</label>
        <select id="decision-assistant-model" [formControl]="modelRoute">
          @for (model of assistant.models; track model.route) {
            <option [value]="model.route">{{ model.label }}</option>
          }
        </select>
        <label for="decision-assistant-question">Your question</label>
        <textarea
          id="decision-assistant-question"
          [formControl]="question"
          [attr.maxlength]="maxQuestionLength"
          rows="3"
          autocomplete="off"
          aria-describedby="decision-assistant-boundary"
        ></textarea>
        <small id="decision-assistant-boundary">
          The answer is grounded in this recorded presentation and is not added to your decision. Do
          not include credentials or personal data.
        </small>
        @if (error(); as message) {
          <p class="assistant-error" role="alert">{{ message }}</p>
        }
        <div class="assistant-actions">
          <button type="button" [disabled]="asking()" (click)="ask()">
            {{ asking() ? 'Asking…' : error() ? 'Retry' : 'Ask' }}
          </button>
        </div>
      </div>
    </div>
  }
</details>
